module.exports = __webpack_public_path__ + "static/media/quadrant-crypto-enthusiasts-devs.78c4454a.svg";